// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import * as WrapperCore from '@angular/core';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
import * as WrapperServices from '../generated/api/observability.service';
// </generated-client-wrappers:imports>
import { HttpClient, HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { REQUEST_META_DATA } from '@seech-sub/core-ng';
import { Observable } from 'rxjs';
import { OperationsApiRoutes } from '../constants/operations.constants';
import {
  AnalyticsLog,
  DiagnosticLog,
  FreezeJobRequest,
  JobDefinition,
  JobRunResult,
  MaintenanceJobLog,
  ObservabilityQuery,
  ObservabilityRangeQuery,
  ObservabilitySummary,
  PagedResult,
  ProviderOperationsQuery,
  ProviderOperationsSnapshot,
  RequestLog,
  UserActivityLog,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class ObservabilityClientService {
  private readonly quietContext = new HttpContext().set(REQUEST_META_DATA.HIDE_PROGRESS, true);
  private readonly http = inject(HttpClient);

  getPaymentProviderOperations(query: ProviderOperationsQuery): Observable<ProviderOperationsSnapshot> {
    const params: Record<string, string | number> = {
      failurePage: query.failurePage,
      failurePageSize: query.failurePageSize,
      planChangePage: query.planChangePage,
      planChangePageSize: query.planChangePageSize,
    };
    if (query.failureStartUnixMilliseconds !== undefined) {
      params['failureStartUnixMilliseconds'] = query.failureStartUnixMilliseconds;
    }
    if (query.failureEndUnixMilliseconds !== undefined) {
      params['failureEndUnixMilliseconds'] = query.failureEndUnixMilliseconds;
    }

    return this.http.get<ProviderOperationsSnapshot>(OperationsApiRoutes.paymentProviders, {
      context: this.quietContext,
      params,
    });
  }

  getObservabilitySummary(query: ObservabilityRangeQuery): Observable<ObservabilitySummary> {
    return this.http.post<ObservabilitySummary>(OperationsApiRoutes.observabilitySummary, query, {
      context: this.quietContext,
    });
  }

  queryDiagnostics(query: ObservabilityQuery): Observable<PagedResult<DiagnosticLog>> {
    return this.http.post<PagedResult<DiagnosticLog>>(OperationsApiRoutes.observabilityDiagnosticsQuery, query, {
      context: this.quietContext,
    });
  }

  queryAnalytics(query: ObservabilityQuery): Observable<PagedResult<AnalyticsLog>> {
    return this.http.post<PagedResult<AnalyticsLog>>(OperationsApiRoutes.observabilityAnalyticsQuery, query, {
      context: this.quietContext,
    });
  }

  queryRequestLogs(query: ObservabilityQuery): Observable<PagedResult<RequestLog>> {
    return this.http.post<PagedResult<RequestLog>>(OperationsApiRoutes.observabilityRequestsQuery, query, {
      context: this.quietContext,
    });
  }

  queryUserActivity(query: ObservabilityQuery): Observable<PagedResult<UserActivityLog>> {
    return this.http.post<PagedResult<UserActivityLog>>(OperationsApiRoutes.observabilityUserActivityQuery, query, {
      context: this.quietContext,
    });
  }

  queryMaintenanceJobs(query: ObservabilityQuery): Observable<PagedResult<MaintenanceJobLog>> {
    return this.http.post<PagedResult<MaintenanceJobLog>>(OperationsApiRoutes.observabilityMaintenanceJobsQuery, query, {
      context: this.quietContext,
    });
  }

  getJobs(): Observable<JobDefinition[]> {
    return this.http.get<JobDefinition[]>(OperationsApiRoutes.jobs, {
      context: this.quietContext,
    });
  }

  runJob(key: string): Observable<JobRunResult> {
    return this.http.post<JobRunResult>(OperationsApiRoutes.jobRun(key), null);
  }

  freezeJob(key: string, request: FreezeJobRequest): Observable<JobDefinition> {
    return this.http.post<JobDefinition>(OperationsApiRoutes.jobFreeze(key), request);
  }

  unfreezeJob(key: string): Observable<JobDefinition> {
    return this.http.delete<JobDefinition>(OperationsApiRoutes.jobFreeze(key));
  }
  // <generated-client-wrappers:methods>
  private readonly wrapperGeneratedClient = WrapperCore.inject(
    WrapperServices.ObservabilityService,
    { optional: true },
  );

  getDiagnostic(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.DiagnosticLogResponse> {
    if (!this.wrapperGeneratedClient)
      throw new Error('ObservabilityService is not available');
    return this.wrapperGeneratedClient.observabilityGetDiagnostic(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  queryRequests(
    query: WrapperApi.ObservabilityQuery,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.ObservabilityPageOfRequestLogResponse> {
    if (!this.wrapperGeneratedClient)
      throw new Error('ObservabilityService is not available');
    return this.wrapperGeneratedClient.observabilityQueryRequests(
      query,
      'body',
      reportProgress,
      options,
    );
  }

  summary(
    query: WrapperApi.ObservabilityRangeQuery,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.ObservabilitySummaryResponse> {
    if (!this.wrapperGeneratedClient)
      throw new Error('ObservabilityService is not available');
    return this.wrapperGeneratedClient.observabilitySummary(
      query,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
